import { Link as GatsbyLink } from 'gatsby'
import { useMemo } from 'react'

export function getEnhancedUrl(to: string): string {
    if (typeof window === 'undefined') {
        return to
    }

    let url
    let params
    try {
        url = new URL(to, window.location.origin)
        params = new URLSearchParams(window.location.search)
    } catch {
        return to
    }

    // Merge existing params from target with current params
    params.forEach((value, key) => {
        if (!url.searchParams.has(key)) {
            url.searchParams.set(key, value)
        }
    })

    return url.toString().replace(window.location.origin, '')
}

export default function EnhancedLink({
    to,
    children,
    ...props
}: { to: string; children?: React.ReactNode } & React.AnchorHTMLAttributes<HTMLAnchorElement>) {
    // const cleaned = to?.replace(/^https?:\/\/(?:www\.)?internations\.org/, '')
    const isGatsby = /\/(magazine|expat\-insider|[\w-]+\-expats).*?/.test(to)
    const enhancedTo = useMemo(() => {
        return getEnhancedUrl(to)
    }, [to])

    if (to?.startsWith('#') || to?.startsWith('mailto:')) {
        // internal anchor — use plain <a>
        return (
            <a href={to} {...props}>
                {children}
            </a>
        )
    }

    if (isGatsby) {
        return (
            <GatsbyLink to={enhancedTo} {...props} suppressHydrationWarning>
                {children}
            </GatsbyLink>
        )
    }

    return (
        <a href={enhancedTo} {...props} target="_blank" suppressHydrationWarning>
            {children}
        </a>
    )
}
